import { asyncAction, actionCreators } from 'lib/actionCreators'

export const countries = asyncAction('profile/COUNTRIES')
export const cities = asyncAction('profile/CITIES')
export const clearCities = actionCreators('profile/CLEAR_CITIES')
